var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status",staticStyle:{"justify-content":"flex-start"}},[_c('span',{staticClass:"status-label"},[_vm._v(" Status: ")]),_c('span',{staticClass:"status-title"},[_vm._v(_vm._s(_vm.status))])])}
var staticRenderFns = []

export { render, staticRenderFns }